import cn from 'clsx'
import { Button, Copy } from 'shared-components'
import { getSanityLink } from 'shared-functions'

import { type InductionSteps as InductionStepsType } from '../../../../../apps/benmax/src/types/sanity.types'

import s from './InductionSteps.module.sass'


function InductionSteps({ preTitle, steps }: InductionStepsType) {
    return (
        <section className={cn(s.InductionSteps, 'container')}>
            {steps?.map((step, index) => {
                const { title, link, copy } = step
                const _link = link?.linkType === 'internal' || link?.linkType === 'external' ? getSanityLink(link) || null : null

                return (

                    <div key={step._key} className={s.Step}>
                        {index === 0 && preTitle && <p className={cn(s.PreTitle, 'smallCaps manrope')}>{preTitle}</p>}
                        <div className={s.Content}>
                            <div className={s.Left}>
                                <h2>{title}</h2>
                                {_link && <Button url={_link?.url || ''} title={_link?.title || ''} />}
                            </div>

                            <div className={s.Right}>
                                <Copy copy={copy} />
                            </div>
                        </div>
                    </div>
                )
            })}
        </section>
    )
}

export default InductionSteps
